import { REQUEST_TABLE_DATA } from "../../utils/constants";

export function getTableData(pagination) {
  return { type: REQUEST_TABLE_DATA, payload: pagination };
}

export const actions = { getTableData };
